import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Wrapper from "../../StylesWrappers/Stat/stat";
import StatCard from "../../components/Stats/StatCard";
import {
  PendingIcon,
  InterviewIcon,
  DeclineIcon,
} from "../../assets/icons/icons";
import TitleText from "../../components/General/Helmet";
import StatCardSkeleton from "../../components/Skeletons/StatCardSkeleton";
import { AppDispatch, RootState } from "../../store";
import {
  declinedCount,
  interviewCount,
  pendingCount,
} from "../../features/stat/statSlice";

const Stat = () => {
  const {
    countPending,
    countDecline,
    countInterview,
    statLoading,
    currentStatusPage,
    pageStatusSize,
  } = useSelector((store: RootState) => store.statStore);

  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  // Navigate to status page on click on any stat status card
  const handleNavigation = (status: string) => {
    if (status === "pending") {
      navigate("/dashboard/pending");
      return;
    }
    if (status === "interview") {
      navigate("/dashboard/interview");
      return;
    }
    if (status === "decline") {
      navigate("/dashboard/decline");
    }
  };

  // FETCH DIFFERENT STATUS JOB COUNT
  useEffect(() => {
    dispatch(pendingCount({ currentStatusPage, pageStatusSize }));
    dispatch(interviewCount({ currentStatusPage, pageStatusSize }));
    dispatch(declinedCount({ currentStatusPage, pageStatusSize }));
  }, [dispatch, currentStatusPage, pageStatusSize]);

  if (statLoading) {
    return <StatCardSkeleton />;
  }

  return (
    <Wrapper>
      <TitleText title="Jobtrackier - Stat" />
      <section className="card-con">
        <StatCard
          count={countPending}
          icon={<PendingIcon />}
          jobText="Pending Applications"
          border="add-pending-border"
          countColor="add-pending-count"
          iconColor="add-pending-icon"
          handleClick={() => handleNavigation("pending")}
        />
        <StatCard
          count={countInterview}
          icon={<InterviewIcon />}
          jobText="Interviews Scheduled"
          border="add-interview-border"
          countColor="add-interview-count"
          iconColor="add-interview-icon"
          handleClick={() => handleNavigation("interview")}
        />
        <StatCard
          count={countDecline}
          icon={<DeclineIcon />}
          jobText="Jobs Declined"
          border="add-decline-border"
          countColor="add-decline-count"
          iconColor="add-decline-icon"
          handleClick={() => handleNavigation("decline")}
        />
      </section>
    </Wrapper>
  );
};

export default Stat;
